export const DocumentTextIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg {...props} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="vuesax/linear/document-text">
      <g id="document-text">
        <path
          id="Vector"
          d="M23.8334 10.8333V16.25C23.8334 21.6667 21.6667 23.8333 16.2501 23.8333H9.75008C4.33341 23.8333 2.16675 21.6667 2.16675 16.25V9.75001C2.16675 4.33334 4.33341 2.16667 9.75008 2.16667H15.1667"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M23.8334 10.8333H19.5001C16.2501 10.8333 15.1667 9.75 15.1667 6.5V2.16667L23.8334 10.8333Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M7.58325 14.0833H14.0833"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M7.58325 18.4167H11.9166"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
